var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cAgreeChoice-container"},_vm._l((_vm.selectdata),function(item,index){return _c('li',{key:index,staticClass:"select-item",class:{
      'select-active': item.isActive
    },on:{"click":function($event){return _vm.handelSelect(item)}}},[_c('img',{attrs:{"src":item.isActive
          ? require('@/assets/img/checkbox_check.png')
          : require('@/assets/img/checkbox.png')}}),_vm._v("\n    "+_vm._s(item.value)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f45aab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Select/cArgeeChoice.vue
// module id = null
// module chunks = 